import { AnalyticsBrowser } from '@segment/analytics-next';
import { config } from '@app/config';

import globalEnrichmentPlugin from './plugins/globalEnrichmentPlugin';
import modelEnrichmentPlugin from './plugins/modelEnrichmentPlugin';
import quantumMetricPlugin from './plugins/quantumMetricPlugin';
import blockNonInteractiveUsers from './plugins/blockNonInteractiveUsers';
import blockOptedOutUsers from './plugins/blockOptedOutUsers';

const analytics = new AnalyticsBrowser();

let isLoaded: boolean = false;

const settings = {
  writeKey: config.SERVICES.SEGMENT.KEY,
  cdnURL: config.SERVICES.SEGMENT.CDN_URL,
  plugins: [
    blockNonInteractiveUsers,
    blockOptedOutUsers,
    globalEnrichmentPlugin,
    modelEnrichmentPlugin,
    quantumMetricPlugin,
  ],
};

/**
 *
 */
export const load = () => {
  if (isLoaded) {
    return;
  }

  isLoaded = true;
  analytics.load(settings);
};

/**
 *
 */
export const unload = () => {
  if (!isLoaded) {
    return;
  }

  isLoaded = false;
  analytics.reset();
};

export default analytics;
